import React from "react";

const Button = ({ btnName, style, onClick, disabled, className }) => {
  return (
    <div>
      <button
        onClick={onClick}
        className={`font-semibold rounded-xl ${className || ""}`}
        style={style}
        disabled={disabled}
      >
        {btnName}
      </button>
    </div>
  );
};


export default Button;
